import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import {
  qalBoxSearchDisplayCategoriesAdPool,
} from '../../services/mp-cf-api-service';

const displayCategoriesAdPoolSearch = () => {
  const [ responseData, setResponseData ] = useState({ });
  const [ updateData, setOperationData ] = useState(null);
  const {
    searchConfig,
    onOperationComplete,
  } = updateData || {};

  const getDisplayCategoryAdPoolItems = async () => {
    try {
      console.log(`QalBox searching display categories...`);
      setResponseData({
        isLoading: true,
        isError: false,
      });

      const mediaItemsApiResp = await qalBoxSearchDisplayCategoriesAdPool({
        data: searchConfig,
      });

      const responseData = _.get(mediaItemsApiResp, 'data', {});

      console.log(responseData)
      
      let errorMsg = null;
      let isError = false;

      if(responseData.success) {
        console.log('QalBox search display categories items add/update Success!!');
      } else {
        console.log('QalBox search display categories items add/update Failed!!');
        errorMsg = `Failed to search QalBox display categories items.`;
        isError = true;
      }

      setResponseData({
        isLoading: false,
        isError,
        errorMsg,
        data: responseData.payload,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError,
          errorMsg,
          data: responseData.payload,
        });
      }
    } catch (err) {
      console.log('Something went wrong while searching QalBox display categories items. ', err);
      const errorMsg = `Error occurred while searching QalBox display categories items.`;
      setResponseData({
        isLoading: false,
        isError: true,
        errorMsg,
        data: null,
      });
      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
          data: null,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(updateData)) {
      getDisplayCategoryAdPoolItems();
    }
  }, [ updateData ]);

  return [
    responseData,
    setOperationData,
  ];
};

export default displayCategoriesAdPoolSearch;
